<template>
  <section id="menufiltre">
      <!-- Menu -->
    <div>
        <nav class="bgfiltre">
            <div v-if="hasAll" class="menudestop grid-pad">
                <ul class="menu">
                <li v-for="s in sections" :key="s.prop"
                    @mouseenter="openKey = s.key" @mouseleave="openKey = null">
                    <button class="toplink" @click.prevent="toggleMenu(s.key)">
                        - {{ menu[s.prop].title }} -
                    </button>

                    <ul class="submenu" :class="{ open: openKey === s.key }">
                        <li v-for="(item, idx) in menu[s.prop].items" :key="item.code || idx">
                            <a v-if="item.availability" @click.prevent="changeSelection(item.code,1)">
                            {{ item.title }}
                            </a>
                        </li>
                    </ul>
                </li>
                </ul>
            </div>
        </nav>
    </div>
    <div class="filterZone grid">
      <!-- Zone des critères sélectionnés -->
      <div id="zoneCriteria" v-if="hasAll" class="grid-pad">
        <template v-for="s in sections" :key="s.key">
          <div v-if="isAnySelected(s.key)">
            <span class="titlefilter">{{ menu[s.prop].title }}</span>
          </div>
          <div v-for="(item, index) in menu[s.prop].items" :key="item.code || index">
            <span
              v-if="item.selected === 1"
              class="itemfilter"
              @click="changeSelection(item.code, 0)"
            >
              {{ item.title }}
            </span>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style>
/* (tes styles inchangés) */
.bgfiltre { background-color: rgb(var(--gray)); background-position: center; background-size: cover; background-repeat: no-repeat; }
.filterZone h1 { margin: 0; }
.container-filter { width: 100%; margin-left: auto; margin-right: auto; }
.filter-item { float: left; padding: 30px 10px; }
.filter-item a { color: black; text-decoration: none; }
.filter-item img { object-fit: cover; height: 350px; }
.resultsearch { padding: 5px; float: left; }
.resultatbdfilter { float: right; font-weight: 700; }
.borderdown { border-bottom: solid #000 1px; }

.filterZone{background-color: rgb(var(--gray));}
#zoneCriteria { height: 40px; width: 100%; }
#zoneCriteria .titlefilter { font-family: TxtOffBDI; color: #fff; float: left; display: inline-block; font-size: 13px; font-weight: 700; text-transform: uppercase; margin: 6px; line-height: 1; }
#zoneCriteria .itemfilter { font-family: TxtOffBDI; color: #fff; float: left; display: inline-block; padding: 1px 15px 6px 4px; font-size: 13px; cursor: pointer; background-color: black; line-height: 1; margin-right: 10px; }
#zoneCriteria .itemfilter:hover { background-color: dimgray; }
.itemfilter:before { content: "\00d7"; color: #fff; font-weight: bold; font-size: 20px; padding-right: 8px; }
.itemfilter:hover:before { color: #f00; }
#zoneCriteria .itemfilter sup { color: red; font-weight: 100; font-size: 12px; padding-right: 10px; padding-top: 5px; }
.titlefilterzone { width: 100%; margin: 0 !important; font: 400 1.8em TxtOffBDI, Arial, Helvetica, sans-serif; color: white; text-transform: uppercase; }


/* layout horizontal des tops */
.menu { display:flex; gap:24px; list-style:none; margin:0; padding:0; height:53px; align-items:center; }
.menu > li { position:relative; }

/* bouton top */
.toplink {font-family: TxtOffBDI; width: 100%; background-color: black; color: white; padding: 5px 100px; margin: 20px 0px; text-transform: uppercase; cursor:pointer; }
/* sous-menu caché par défaut */
.submenu {  position:absolute; top:55px; left:0; min-width:220px; display:none; list-style:none; margin:0; padding:0px 0; background:rgb(var(--ligthGray)); box-shadow:0 8px 20px rgba(0,0,0,.15); z-index:50; }

/* hover desktop */
.menu > li:hover > .submenu { display:block; }

/* ouverture via classe (mobile / clic) */
.submenu.open { display:block; }

/* items du sous-menu */
.submenu li a { display:block; padding:8px 12px; color:#333; text-decoration:none; font-family: TxtOffBDI; }
.submenu li a:hover { color:rgb(var(--secondary)); cursor: pointer; }


  @media handheld, only screen and (max-width: 960px) {
    .menu { display:block; height:100%; }
    .toplink { padding: 5px; margin: 10px 0px; }
  }
</style>

<script>
export default {
  name: 'Filter',
  data: () => ({
    params: "",
    errorMessage: "",
    menu: {},
    openKey: null,
    byCode: null, // index code -> item
  }),
  computed: {
    hasAll() { return !!(this.menu?.Brand && this.menu?.Transmission && this.menu?.Engine && this.menu?.Serie);},
    sections() {
      return [
        { key: 'B', prop: 'Brand' },
        { key: 'T', prop: 'Transmission' },
        { key: 'E', prop: 'Engine' },
        { key: 'S', prop: 'Serie' },
      ];
    },
    groups() {
      return {
        B: this.menu?.Brand?.items ?? [],
        T: this.menu?.Transmission?.items ?? [],
        E: this.menu?.Engine?.items ?? [],
        S: this.menu?.Serie?.items ?? [],
      };
    },
  },
  async mounted() {
    try {
      this.paramInit();
      await this.dataRead();
    } catch (error) {
      console.error(error);
      this.errorMessage = error?.toString?.() || String(error);
    }
  },
  methods: {
    paramInit() {
      const usp = new URLSearchParams(window.location.search);
      this.params = usp.get('params') || "";
    },

    async dataRead() {
      const api = '../ressources/json/filters.json';
      try {
        const response = await fetch(api);
        const data = await response.json();
        this.menu = data;
        this.buildCodeIndex();
        this.paramSelection();
      } catch (error) {
        console.error(error);
        this.errorMessage = error?.toString?.() || String(error);
      }
    },

    buildCodeIndex() {
      const parts = [
        ...(this.menu?.Brand?.items ?? []),
        ...(this.menu?.Transmission?.items ?? []),
        ...(this.menu?.Engine?.items ?? []),
        ...(this.menu?.Serie?.items ?? []),
      ];
      this.byCode = Object.fromEntries(parts.map(i => [i.code, i]));
    },

    codesFromParams() {
      return String(this.params)
        .replaceAll(";", ",")
        .split(",")
        .map(s => s.trim())
        .filter(Boolean);
    },

    paramSelection() {
      if (!this.params) {
        this.updateAvailability();
        return;
      }
      const codes = this.codesFromParams();
      for (const code of codes) {
        const item = this.byCode?.[code];
        if (item) item.selected = 1;
      }
      this.updateAvailability();
    },

    changeSelection(code, selection) {
      if (!code) return;

      const groupKey = code[0];
      const items = this.groups[groupKey] || [];
      // Sélection unique par groupe
      for (const it of items) {
        it.selected = (it.code === code && selection === 1) ? 1 : 0;
      }

      this.updateAvailability();

      const params = this.getSelectedCode();
      // conserve ton event bus
      $App.event.$emit("truck_selection_changed", params);
    },

    getSelectedCode() {
      const all = []
        .concat(this.groups.B, this.groups.T, this.groups.E, this.groups.S)
        .filter(Boolean);
      const codes = all.filter(i => i.selected === 1).map(i => i.code);
      return codes.join(",");
    },

    isAnySelected(letter) {
      const arr = this.groups[letter] || [];
      return arr.some(i => i.selected === 1);
    },

    updateAvailability() {
      // La série est dispo seulement si au moins UNE marque est sélectionnée
        const allowSerie = this.brandIsInternationalSelected();

        for (const s of this.groups.S) {
            s.availability = allowSerie ? 1 : 0;
            if (!allowSerie) s.selected = 0; // on déselectionne si la condition n'est plus vraie
        }
    },
    toggleMenu(key) {
        this.openKey = (this.openKey === key) ? null : key;
    },
    isInternational(item) {
        const t = (item.title || "").trim().toLowerCase();
        const c = (item.code  || "").toUpperCase();
        // Adapte la whitelist de codes au besoin
        const CODE_OK = new Set(["INT", "BINT", "BRAND-INT"]);
        return t === "international" || CODE_OK.has(c) || /(?:^|-)INT(?:$|-)/.test(c);
    },
    brandIsInternationalSelected() {
        return (this.groups.B || []).some(it => it.selected === 1 && this.isInternational(it));
    },
  },
  components: {}
}
</script>
